import type { Porch } from "building-types/porches/porch";
import type { PorchHeaderKeyMeasures, PorchKeyMeasures } from "building-types/porches/porchKeyMeasuresTypes";
import type { Table } from "common/data/table";
import type { PolyLine3 } from "geom/polyLine3";
import { polyLine3EdgeCount, polyLine3Length } from "geom/polyLine3";
import { formatInchesFraction } from "../measurementUtils";

export function porchHeaderKeyMeasuresNew(rail: PolyLine3, width: number, depth: number): PorchHeaderKeyMeasures {
  return {
    rail,
    width,
    depth,
  };
}

export function porchKeyMeasuresNew(): PorchKeyMeasures {
  return {
    columnHeight: 0,
    columnCount: 0,
    headers: [],
    name: "",
  };
}

export interface PorchKeyMeasuresAggregated {
  columns: PorchColumnStringKeyMeasures[];
  headerLinearFeet: number;
  headerCount: number;
}

export interface PorchColumnStringKeyMeasures {
  columnHeight: string;
  columnCount: number;
}

function porchKeyMeasuresAggregatedNew(): PorchKeyMeasuresAggregated {
  return {
    columns: [],
    headerLinearFeet: 0,
    headerCount: 0,
  };
}

export function porchKeyMeasuresAggregate(porches: Table<Porch>, columnHeightDenom = 8): PorchKeyMeasuresAggregated {
  const keyMeasures = porchKeyMeasuresAggregatedNew();
  const columnCountPerHeight: { [columnHeight: number]: number } = {};
  for (const { columnHeight, columnCount, headers } of Object.values(porches).map((x) => x.keyMeasures)) {
    const heightInFtInches = formatInchesFraction(columnHeight, columnHeightDenom);
    let currentcount = columnCountPerHeight[heightInFtInches] ?? 0;
    currentcount += columnCount;
    columnCountPerHeight[heightInFtInches] = currentcount;

    for (const { rail } of headers) {
      keyMeasures.headerLinearFeet += polyLine3Length(rail);
      keyMeasures.headerCount += polyLine3EdgeCount(rail);
    }
  }

  for (const height in columnCountPerHeight) {
    keyMeasures.columns.push({
      columnCount: columnCountPerHeight[height],
      columnHeight: height,
    });
  }

  return keyMeasures;
}
